function isFunction(value) {
    return typeof value === 'function';
}

module.exports = isFunction;
